var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83327 24.0001C8.16964 24.0001 6.57415 23.368 5.39779 22.2427C4.22142 21.1175 3.56055 19.5914 3.56055 18.0001C3.56055 16.4088 4.22142 14.8827 5.39779 13.7575C6.57415 12.6322 8.16964 12.0001 9.83327 12.0001C10.2262 10.2497 11.3756 8.71141 13.0287 7.72372C13.8473 7.23466 14.7648 6.89549 15.729 6.72558C16.6931 6.55567 17.6851 6.55834 18.6481 6.73343C19.6111 6.90853 20.5264 7.25262 21.3417 7.74607C22.1569 8.23952 22.8562 8.87266 23.3996 9.60934C23.943 10.346 24.3199 11.1718 24.5087 12.0396C24.6975 12.9073 24.6945 13.8 24.4999 14.6668H25.8333C27.071 14.6668 28.2579 15.1584 29.1331 16.0336C30.0083 16.9088 30.4999 18.0958 30.4999 19.3334C30.4999 20.5711 30.0083 21.7581 29.1331 22.6333C28.2579 23.5084 27.071 24.0001 25.8333 24.0001H24.4999",
    stroke: "#DD1E2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20L16.5 16L20.5 20",
    stroke: "#DD1E2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16V28",
    stroke: "#DD1E2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.407f49276e9754bf998eae5bc2a2af68.svg";
export { ForwardRef as ReactComponent };